import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LogIn, Sparkles, ArrowRight, MessageCircle } from "lucide-react";
import Layout from "../components/Layout";
import { whatsappLink } from "../lib/whatsapp";

/**
 * Account — placeholder customer portal page.
 * The real portal isn't built yet; this page sells the concept and offers
 * the bilingual WhatsApp fallback so users never hit a dead-end.
 */
export default function Account() {
  const { t } = useTranslation();
  return (
    <Layout>
      <Helmet>
        <title>{t("accountPage.metaTitle")} — Velcor Energy</title>
      </Helmet>
      <section className="min-h-[78vh] grid place-items-center bg-velcor-cream py-20" data-testid="account-page">
        <div className="max-w-[600px] mx-auto px-5 text-center">
          <span className="inline-grid place-items-center w-14 h-14 rounded-2xl bg-velcor-green/10 text-velcor-green mb-5">
            <LogIn className="w-6 h-6" strokeWidth={1.8} />
          </span>
          <span className="inline-block text-velcor-green mb-2" style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.22em", textTransform: "uppercase" }}>
            {t("accountPage.kicker")}
          </span>
          <h1 className="display text-velcor-ink leading-[1.05]" style={{ fontSize: "clamp(30px, 4.4vw, 48px)" }}>
            {t("accountPage.titlePre")}{" "}
            <span className="display-accent">{t("accountPage.titleAccent")}</span>
          </h1>
          <p className="mt-5 text-slate-600 leading-relaxed" style={{ fontSize: 15.5 }}>
            {t("accountPage.body")}
          </p>

          <div className="mt-7 inline-flex items-center gap-1.5 rounded-full bg-amber-50 border border-amber-200 px-4 py-2 text-[12.5px] font-extrabold text-amber-800">
            <Sparkles className="w-3.5 h-3.5" />
            {t("accountPage.soon")}
          </div>

          <div className="mt-10 flex flex-wrap justify-center gap-3">
            <a
              href={whatsappLink(t("accountPage.waPrefill"))}
              target="_blank"
              rel="noreferrer"
              className="btn-green inline-flex items-center h-12 px-6"
              data-testid="account-whatsapp"
            >
              <MessageCircle className="w-4 h-4 mr-2" />
              {t("accountPage.waCta")}
            </a>
            <Link
              to="/"
              className="inline-flex items-center h-12 px-6 rounded-full border-2 border-velcor-ink/15 hover:border-velcor-green hover:text-velcor-green text-velcor-ink font-extrabold text-[14px] transition-all"
              data-testid="account-back"
            >
              {t("accountPage.back")}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
